const LauncherCDNHost = {
		dev: 'https://dev-nxl.d.nexon.io',
		testPre: 'https://test-nxl.nxfs.nexon.com',
		test: 'https://test-nxl.nxfs.nexon.com',
		pre: 'https://pre-nxl.nxfs.nexon.com',
		prod: 'https://nxl.nxfs.nexon.com',
	},
	locale = {
		en: 'en-US',
		de: 'de-DE',
		es: 'es-419',
		fr: 'fr-FR',
		it: 'it-IT',
		nl: 'nl-NL',
		pl: 'pl-PL',
		pt: 'pt-BR',
		tr: 'tr-TR',
		ko: 'ko-KR',
		th: 'th-TH',
		zh: 'zh-TW',
		vi: 'vi-VN',
		ru: 'ru-RU',
	},
	RegionCode = {
		global: '1',
		th: '3',
		tw: '4',
		sea: '5',
	},
	LauncherDownloadHost = {
		dev: 'https://dev-download.d.nexon.io/download-launcher',
		testPre: 'https://test-download.nxfs.nexon.com/download-launcher',
		test: 'https://test-download.nxfs.nexon.com/download-launcher',
		pre: 'https://pre-download.nxfs.nexon.com/download-launcher',
		prod: 'https://download.nxfs.nexon.com/download-launcher',
	},
	LauncherDownloadHostMac = {
		dev: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
		testPre: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
		test: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
		pre: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
		prod: 'https://download2.nexon.net/gms/mac/live/MapleStory.pkg',
	},
	SupportLinks = {
		global: 'https://support.nexon.net/',
		one: 'https://support.nexon.net/',
		th: '/help/home',
		tw: '/help/home',
		sea: '/help/home',
		vietnam: '/help/vi',
	};

export default { LauncherCDNHost, locale, RegionCode, LauncherDownloadHost, SupportLinks, LauncherDownloadHostMac };
export { LauncherCDNHost, locale, RegionCode, LauncherDownloadHost, SupportLinks, LauncherDownloadHostMac };
